module.exports = __webpack_public_path__ + "media/images/stock_groups/f05b-b2d08484636a780369c4b59782964e76.svg";